import { createFiltersSelectionMapper, type FiltersSelectionMapper } from '../api/filtersSelectionMapper';

import {
  createQueryStringSerializer,
  type QueryStringSerializer,
} from '@/scopes/common/infrastructure/query-strings/queryStringSerializer';
import type { SearchPagination, SearchFilters, FiltersSelection, SearchSorting } from '../api/types';

interface Dependencies {
  filterSelectionMapper: FiltersSelectionMapper<SearchFilters>;
  queryStringSerializer: QueryStringSerializer;
}

interface Criteria {
  pagination: SearchPagination;
  sorting: SearchSorting;
  filterSelection: FiltersSelection<SearchFilters>;
}

export const createSearchPageQueryBuilder = (dependencies: Partial<Dependencies> = {}) => {
  const {
    filterSelectionMapper = createFiltersSelectionMapper<SearchFilters>(),
    queryStringSerializer = createQueryStringSerializer(),
  } = dependencies as Dependencies;

  function build({ pagination, sorting, filterSelection }: Criteria) {
    return queryStringSerializer.serialize({
      ...pagination,
      sort: sorting.by,
      ...filterSelectionMapper.map(filterSelection),
    });
  }

  return { build };
};

export const searchPageQueryBuilder = createSearchPageQueryBuilder();
